import LogInForm from "../../components/LogInForm/LogInForm";

const LogInPage = () => {
   return <LogInForm />;
};

export default LogInPage;
